/**
 * Optional absolute API origin (e.g. when the UI is not served from the same host as `/api`).
 * If unset, URLs are same-origin relative (`/api/...`), which matches Vite dev (proxy) and Docker.
 */
export function apiOrigin(): string {
  const o =
    (import.meta.env.VITE_API_ORIGIN as string | undefined) ||
    (import.meta.env.VITE_NETLIFY_FUNCTIONS_ORIGIN as string | undefined);
  return o?.trim() ? o.replace(/\/$/, "") : "";
}

/** @deprecated use apiOrigin */
export function netlifyFunctionsOrigin(): string {
  return apiOrigin();
}

export function apiUrl(apiPath: string): string {
  const p = apiPath.startsWith("/") ? apiPath : `/${apiPath}`;
  const origin = apiOrigin();
  return origin ? `${origin}${p}` : p;
}
